var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.243 0 0 2.243 0 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5Zm4.145 4.583H7.697C7.64 3.246 7.31 2.075 6.805 1.25a4.17 4.17 0 0 1 2.34 3.333ZM4.583.958v3.625H3.135c.088-1.862.746-3.225 1.448-3.625Zm0 4.459v3.625c-.702-.4-1.36-1.763-1.448-3.625h1.448Zm.834 3.625V5.417h1.448c-.088 1.862-.746 3.225-1.448 3.625Zm0-4.459V.958c.702.4 1.36 1.763 1.448 3.625H5.417ZM3.195 1.25c-.504.825-.835 1.996-.892 3.333H.855a4.171 4.171 0 0 1 2.34-3.333ZM.855 5.417h1.448c.057 1.337.388 2.508.892 3.333a4.17 4.17 0 0 1-2.34-3.333Zm5.95 3.333c.504-.825.835-1.996.893-3.333h1.448a4.173 4.173 0 0 1-2.34 3.333Z",
    fill: "#000"
  })));
};

export default SvgGlobe;